//danh sách gói dịch vụ
export const Products_Service = [
    {
    id: 4,
    url: "/assets/GoiCombo/combo4.jpg",
    sub_images: [
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Xông hơi thảo dược",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Ngâm chân thảo dược",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Ngâm lá người Dao (Lưu thông khí huyết)",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Tắm chung cùng KTV",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Thư giản đỉnh cao cảm xúc tại bồn Jacuzzi",
      },
       {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Massager Body",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Trườn NURU nghệ thuật",
      },
     
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Thư giãn đỉnh cao - 2 shot",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Free đồ uống, hoa quả",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Free set ăn đặc biệt cân bằng sinh lực",
      },
    ],
    name: "QUÝ ÔNG QUYỀN LỰC (VIP)",
    desc: "Pool Bar + Thư giãn cơ bản 120 phút",
    time: "120",
    space: "Pool Bar",
    service: "Rượu vang + Trái cây",
    price: "3.200.000",
    price_sale: "5.999.000",
    user: "500",
    vote: "98",
  },
    {
    id: 5,
    url: "/assets/GoiCombo/combo1.jpg",
    sub_images: [
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Xông hơi thảo dược",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Ngâm chân thảo dược",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Ngâm lá người Dao (Lưu thông khí huyết)",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Tắm chung cùng KTV",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Thăng hoa cảm xúc tại bồn Jacuzzi",
      },
       {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Massager Body",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Trườn NURU nghệ thuật",
      },
     
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Thư giãn đỉnh cao - 2 KTV",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Free đồ uống, hoa quả",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Free set ăn đặc biệt cân bằng sinh lực",
      },
    ],
    name: "QUÝ ÔNG SÀNH ĐIỆU (SUPER VIP)",
    desc: "Pool Bar + Thư giãn cơ bản 120 phút",
    time: "100",
    space: "Pool Bar",
    service: "Rượu vang + Trái cây",
    price: "4.000.000",
    price_sale: "6.499.000",
    user: "500",
    vote: "98",
  },
  {
    id: 3,
    url: "/assets/GoiCombo/combo3.jpg",
    sub_images: [
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Thưởng thức âm thanh DJ, ánh sáng đèn Led cao cấp",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Tắm bể sục nước nóng cùng KTV",
      },
       {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Free bia",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Xông hơi, tắm chung",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Massager Body",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Trườn NURU",
      },
       {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Ngâm bồn lá người Dao",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Thư giãn hoàn hảo",
      },
    ],

    name: "QUÝ ÔNG HỘI TỤ (POOL PARTY)",
    desc: " Pool Bar + Thư giãn cơ bản 100 phút ",
    time: "90",
    space: "Pool Bar",
    service: "Rượu vang + Trái cây",
    price: "2.500.000",
    price_sale: "4.599.000",
    user: "500",
    vote: "98",
  },
  {
    id: 1,
    url: "/assets/GoiCombo/combo1.jpg",
    sub_images: [
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Xông hơi thảo dược",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Ngâm lá người Dao (Lưu thông khí huyết)",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Tắm chung bồn cùng KTV",
      },
        {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Massager Body",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Trườn NURU",
      },
    
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Thư giãn hoàn hảo",
      },
       {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Free đồ uống ",
      },
    ],
    name: "QUÝ ÔNG HOÀN HẢO",
    desc: "Pool Bar + Thư giãn cơ bản 70 phút",
    time: "70",
    space: "Pool Bar",
    service: "Rượu vang + Trái cây",
    price: "1.600.000",
    price_sale: "2.999.000",
    user: "500",
    vote: "98",
  },

  {
    id: 2,
    url: "/assets/GoiCombo/combo2.jpg",
    sub_images: [
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Xông hơi thảo dược",
      },
        {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Ngâm chân thảo dược",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Ngâm bồn lá người Dao",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Tắm chung bồn cùng KTV",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Khơi gợi cảm xúc tại bồn Jacuzzi",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Massager Body",
      },
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Trườn NURU nghệ thuật",
      },
      
      {
        url: "/assets/GoiCombo/combo1.jpg",
        title: "Thư giãn thăng hoa",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Free đồ uống, hoa quả ",
      },
      {
        url: "/assets/GoiCombo/combo2.jpg",
        title: "Free set đồ ăn nhẹ",
      },
    ],
    name: "QUÝ ÔNG ĐẲNG CẤP",
    desc: "Pool Bar + Thư giãn cơ bản 80 phút",
    time: "80",
    space: "Pool Bar",
    service: "Rượu vang + Trái cây",
    price: "2.200.000",
    price_sale: "3.999.000",
    user: "500",
    vote: "98",
  },

];
